// extracted by mini-css-extract-plugin
export default {"eventInfo":"x336W1","multiDay":"Yg_iyz","time":"B11jYK","title":"OyuNR8"};